import { Loader2, Star, Trash2 } from 'lucide-react';
import { Button } from '../ui/button';

export const FavoriteMealsSection = ({ favorites, onRemove, removing }) => {
  if (!favorites || favorites.length === 0) {
    return (
      <div className="mt-4 pt-4 border-t border-border">
        <div className="flex items-center gap-2 mb-2">
          <Star className="h-4 w-4 text-yellow-400" />
          <span className="font-heading text-sm text-white uppercase tracking-wider">Favorite Meals</span>
        </div>
        <p className="text-muted-foreground text-xs">
          Star meals you love while swapping — they'll automatically influence your next plan regeneration.
        </p>
      </div>
    );
  }

  return (
    <div className="mt-4 pt-4 border-t border-border" data-testid="favorites-section">
      <div className="flex items-center gap-2 mb-3">
        <Star className="h-4 w-4 text-yellow-400 fill-current" />
        <span className="font-heading text-sm text-white uppercase tracking-wider">
          My Favorite Meals ({favorites.length})
        </span>
      </div>
      <p className="text-muted-foreground text-xs mb-3">
        These meals will inspire future regenerations — similar dishes will appear automatically.
      </p>
      <div className="space-y-2">
        {favorites.map((fav) => {
          const m = fav.meal || {};
          return (
            <div
              key={fav.id}
              className="bg-black border border-yellow-500/20 p-3 rounded"
              data-testid={`favorite-meal-${fav.id}`}
            >
              <div className="flex items-start justify-between gap-2">
                <div className="flex-1 min-w-0">
                  <p className="text-white text-sm mb-1.5">{m.foods}</p>
                  <div className="flex gap-3 text-xs flex-wrap">
                    <span className="text-muted-foreground">{m.calories} cal</span>
                    <span className="text-red-400">{m.protein_g}g P</span>
                    <span className="text-yellow-400">{m.carbs_g}g C</span>
                    <span className="text-blue-400">{m.fats_g}g F</span>
                  </div>
                </div>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => onRemove(fav.id)}
                  disabled={removing === fav.id}
                  className="text-muted-foreground hover:text-red-400 flex-shrink-0 h-8 w-8 p-0"
                  data-testid={`remove-favorite-${fav.id}`}
                  title="Remove from favorites"
                >
                  {removing === fav.id ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Trash2 className="h-3.5 w-3.5" />}
                </Button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
